export const PARTNER_BANNER_ROUTER_ROOT = '/banners';



// WEBPACK FOOTER //
// ./src/components/Partner/constants.js